import assign from 'lodash/assign';
import merge from 'lodash/merge';
import noop from 'lodash/noop';
import omit from 'lodash/omit';

import {
	SET_CONTEXT,
	SET_HANDLERS,
	INITIAL_REQUEST,
	INITIAL_REQUEST_SUCCESS,
	RELEASE_VERSION_UPDATE,
	RELEASE_VERSION_VALIDATION_FAILURE,
	RELEASE_VERSION_REQUEST,
	RELEASE_VERSION_SUCCESS,
	RELEASE_VERSION_FAILURE,
	SWAP_ISSUES,
	type Action,
	CREATE_RELEASE_NOTES_OPTIONS,
	RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS,
	SET_VERSION_UNRESOLVED_ISSUES_COUNT,
} from './actions';
import type { State } from './types';

export const initialState: State = {
	context: {
		baseUrl: '',
		projectKey: '',
	},
	handlers: {
		onOpened: noop,
		onError: noop,
		onSuccess: noop,
		onCancel: noop,
	},
	version: {
		id: '0',
		name: '',
	},
	unresolvedIssuesCount: 0,
	shouldSwapIssues: true,
	isInitiating: true,
	isSaving: false,
	shouldShowCreateReleaseNotesOption: false,
	hasReleaseNote: false,
	shouldRedirectToCreateReleaseNotes: true,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State = initialState, action: Action): State => {
	switch (action.type) {
		case SET_CONTEXT: {
			const context = action.payload;
			// @ts-expect-error - TS2322 - Type 'SetContextPayload | undefined' is not assignable to type '{ readonly baseUrl: string; readonly projectKey: string; }'.
			return { ...state, context };
		}

		case SET_VERSION_UNRESOLVED_ISSUES_COUNT: {
			const unresolvedIssuesCount = action.payload;
			return {
				...state,
				unresolvedIssuesCount: unresolvedIssuesCount || 0,
			};
		}

		case SWAP_ISSUES: {
			// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
			return { ...state, shouldSwapIssues: action.payload };
		}

		case SET_HANDLERS: {
			const handlers = action.payload;

			return {
				...state,
				handlers: merge({}, state.handlers, handlers),
			};
		}

		case INITIAL_REQUEST_SUCCESS: {
			const version = action.payload;

			// @ts-expect-error - TS2322 - Type 'Pick<{ version: ReleasableVersion | undefined; context: { readonly baseUrl: string; readonly projectKey: string; }; handlers: Handlers; errors?: ReleaseVersionValidationErrors | undefined; isInitiating?: boolean | undefined; isSaving?: boolean | undefined; shouldSwapIssues: boolean; }, "version" | ... 4 more ... | "...' is not assignable to type 'State'.
			return omit(
				{
					...state,
					version,
				},
				'isInitiating',
			);
		}

		case RELEASE_VERSION_UPDATE: {
			const prevVersion = state.version;
			const prevErrors = state.errors;
			const nextVersion = action.payload;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const errors: Record<string, any> = {};

			if (action.payload && action.payload.moveUnfixedIssuesTo) {
				errors.moveUnfixedIssuesTo = '';
			}
			if (action.payload && action.payload.releaseDate) {
				errors.releaseDate = '';
			}

			return {
				...state,
				errors: assign({}, prevErrors, errors),
				version: assign({}, prevVersion, nextVersion),
			};
		}

		case RELEASE_VERSION_VALIDATION_FAILURE: {
			const errors = action.payload;

			return omit(
				{
					...state,
					errors,
				},
				'isSaving',
			);
		}

		case RELEASE_VERSION_REQUEST: {
			return {
				...state,
				isSaving: true,
			};
		}

		case RELEASE_VERSION_SUCCESS:
		case RELEASE_VERSION_FAILURE: {
			return omit(state, 'isSaving');
		}

		case INITIAL_REQUEST: {
			return state;
		}

		case CREATE_RELEASE_NOTES_OPTIONS: {
			return {
				...state,
				...action.payload,
				shouldRedirectToCreateReleaseNotes: !(action.payload?.hasReleaseNote ?? false),
			};
		}

		case RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS: {
			const shouldRedirectToCreateReleaseNotes =
				action.payload !== undefined ? action.payload : false;
			return {
				...state,
				shouldRedirectToCreateReleaseNotes,
			};
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
